<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="450"
      max-height="90%"
      min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{$t('common.table_columns_settings')}}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-data-table
            v-if="isReady"
            :items-per-page="1000"
            hide-default-footer
            :headers="[
          {
            text: $t('common.visibility'),
            align: 'start',
            sortable: false,
            value: 'is_hidden',
          },
          { text: $t('common.title'), value: 'text' },
          { text: '', value: 'align' }]"
            :items="columns"
            v-sortable-data-table
            @sorted="saveOrder"
            item-key="name"
        >
          <template v-slot:item.is_hidden="props">
            <v-simple-checkbox
                :disabled="props.item.is_action_column"
                @click="!props.item.is_action_column ? toggleVisibility(props.item) : null"
                :value="props.item.is_hidden===false"
                class="d-inline"
            />
          </template>
          <template v-slot:item.text="props">
            <span v-if="props.item.is_action_column">
              {{$t('common.actions')}}
            </span>
            <span v-else>{{props.item.text}}</span>
          </template>
          <template v-slot:item.align="props">
            <v-icon class="mr-5 pointer">fa-arrows-alt-v</v-icon>
          </template>
          <template v-slot:no-data>
            {{ $t("common.no_data_available") }}
          </template>
          <template v-slot:no-results>
            {{ $t("common.no_data_available") }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-btn
            class="white--text"
            elevation="0"
            color="warning"
            @click="restore"
            :loading="isLoadingTablesConfig"
            :disabled="isLoadingTablesConfig"
        >
          {{ $t("common.restore_default") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            class="white--text"
            elevation="0"
            color="red"
            @click="hideWin"
            :loading="isLoadingTablesConfig"
            :disabled="isLoadingTablesConfig"
        >
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
            class="white--text"
            elevation="0"
            color="success"
            :loading="isLoadingTablesConfig"
            :disabled="isLoadingTablesConfig || countHiddenColumns === columns.length"
            @click="save"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Sortable from 'sortablejs';
import {mapFields} from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "TableConfig",
  props: {
    table: null,
    defaultColumns: null,
    isVisible: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [CommonMixin],
  data: () => ({
    columns: [],
    isReady: false
  }),
  computed:{
    //
    ...mapFields("tables_config", ["isLoadingTablesConfig", "tablesConfig"]),
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
    countHiddenColumns(){
      return this.columns.filter((el)=>{
        return el.is_hidden===true
      }).length
    }
  },
  methods: {
    toggleVisibility(item){
      this.columns.forEach((el)=>{
        if(el.text === item.text){
          el.is_hidden = !el.is_hidden;
        }
      })
      this.columns = JSON.parse(JSON.stringify(this.columns))
    },
    saveOrder(ordered){
      this.isReady = false;
      let item = JSON.parse(JSON.stringify(this.columns[ordered.oldIndex]))
      this.columns.splice(ordered.oldIndex, 1);
      this.columns.splice(ordered.newIndex, 0, item);
      this.$nextTick(()=>{
        this.isReady = true;
      })
    },
    fill(){
      this.columns = this.getConfiguredTableHeader(this.table, this.defaultColumns);
      this.isReady = true;
      return;
    },
    save() {
      if(this.countHiddenColumns === this.columns.length) return
      let columns = []
      this.columns.forEach((el)=>{
        if(!el.value || el.value===''){
          throw "Empty parameter value for column at save() method";
        }
        let item = {}
        item[el.value] = !el.is_hidden;
        columns.push(item)
      })
      let data = {
        table_name: this.table,
        columns
      };
      this.$store.dispatch("tables_config/update", data).then(()=>{
        this.hideWin();
        this.$store.dispatch("tables_config/get");
      })
    },
    restore() {
      this.$store.dispatch("tables_config/remove", this.table).then(()=>{
        this.$store.dispatch("tables_config/get");
        this.hideWin();
      })
    },
    hideWin() {
      this.isVisibleWindow = false;
    },
  },
  directives: {
    sortableDataTable: {
      bind (el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit('sorted', event)
          }
        }
        Sortable.create(el.getElementsByTagName('tbody')[0], options)
      }
    }
  },
  watch:{
    isVisible(to) {
      if (to) {
        this.$store.dispatch("tables_config/get").then(()=>{
          this.fill();
        })

      }
    },
  }
}
</script>

<style scoped>

</style>